import React from 'react';
import './TypingIndicator.css';

interface TypingIndicatorProps {
    className?: string;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ className = '' }) => {
    return (
        <div className={`typing-indicator-container ${className}`}>
            <div className="typing-indicator">
                <span className="typing-dot"></span>
                <span className="typing-dot"></span>
                <span className="typing-dot"></span>
            </div>
        </div>
    );
};

export default TypingIndicator;
